import { createApiClient } from 'commons/http/createApiClient';
import { config } from 'config';
import { CreditOfferDto } from './dtos/credit-offer.dto';
import { InstallmentPaymentInfoDto } from './dtos/installment-payment-info.dto';

const axios = createApiClient(config.api.lending);

async function getPaymentInfo(
  contractId?: string,
): Promise<InstallmentPaymentInfoDto | undefined> {
  const { data } = await axios.get<InstallmentPaymentInfoDto>(
    '/installments/payment-info',
    { params: { contractId } },
  );

  return data;
}

async function getCreditOffer(): Promise<CreditOfferDto> {
  const { data } = await axios.get<CreditOfferDto>('/leads/offered');
  return data;
}

export default {
  getPaymentInfo,
  getCreditOffer,
};
